module.exports = __webpack_public_path__ + "d8dec11293b74a5bfeb9c44364ad8293.jpg";